<div mat-dialog-title>
  <h2 style="display: inline-block">Detalhes do Processo seletivo</h2>
  <div class="process-list-controls">
    <ng-container *ngIf="!(isSmallScreen$ | async)">
      <button mat-raised-button color="primary" (click)="finishProcess()" *ngIf="processListStatus !== 'finished'">
        Encerrar processo seletivo
      </button>
    </ng-container>
    <ng-container *ngIf="isSmallScreen$ | async">
      <button mat-icon-button color="primary" [matMenuTriggerFor]="matMenuControlMobile">
        <mat-icon>more_vert</mat-icon>
      </button>
    </ng-container>
    <div style="clear: both"></div>
  </div>
</div>
<div class="row">
  <p *ngIf="processListStatus === 'finished'" class="mat-body-2" style="color: #093">
    Esse processo já foi concluído
  </p>
</div>
<mat-dialog-content>
  <div class="controls" *ngIf="processListStatus !== 'finished'">
    <ng-container *ngIf="candidateMode === 'default'">
      <div>
        <button mat-stroked-button color="primary" (click)="addCandidate()">
          Adicionar mais candidatos
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="candidateMode === 'contract'">
      <button mat-stroked-button color="accent" (click)="candidateMode = 'default'">
        Cancelar
      </button>
      <button mat-stroked-button color="primary" (click)="hireCandidates()">
        Contratar
      </button>
    </ng-container>

  </div>

  <mat-action-list *ngIf="candidateMode === 'default'">
    <ng-container *ngFor="let candidate of candidates">
      <button mat-list-item>
        <mat-icon matListIcon *ngIf="candidate.avatar_profile === null">account_circle</mat-icon>
        <img [src]="mediaEndpoint + candidate.avatar_profile" matListAvatar *ngIf="candidate.avatar_profile" />

        <h3 (click)="openCandidate(candidate)" matLine>
          {{ candidate.firstname }} {{ candidate.lastname }}
        </h3>
        <p (click)="openCandidate(candidate)" matLine>{{ candidate.city }}</p>
        <p *ngIf="candidate.candidateStatus === 'hired'" matLine style="color: #093">Contratado</p>
        <ng-container *ngIf="!(isSmallScreen$ | async)">
          <ng-container *ngIf="currentProcessList.status !== 'finished'">
            <button mat-icon-button color="primary" (click)="openCandidateComment(candidate)"
              matTooltip="Adicionar observação para esse candidato">
              <mat-icon>maps_ugc</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="openPoints(candidate)"
              matTooltip="Colocar pontuação do candidato">
              <mat-icon>insights</mat-icon>
            </button>
            <button color="warn" mat-icon-button (click)="deleteLead(candidate)"
              matTooltip="Remover candidato do processo seletivo">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="isSmallScreen$ | async">
          <button mat-icon-button color="primary" [matMenuTriggerFor]="candidateOptionsMenu">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #candidateOptionsMenu="matMenu">
            <button mat-menu-item (click)="openPoints(candidate)">
              <mat-icon>insights</mat-icon>
              Pontuação do candidato
            </button>
            <ng-container *ngIf="currentProcessList.status !== 'finished'">

              <button mat-menu-item (click)="deleteLead(candidate)" style="color: red">
                <mat-icon>delete</mat-icon>
                Remover candidato
              </button>
            </ng-container>
          </mat-menu>
        </ng-container>
      </button>
    </ng-container>
  </mat-action-list>

  <ng-container *ngIf="!submiting && candidates?.length === 0">
    <div class="empty-content">
      <span class="mat-body-2" style="text-align: center;">Candidatos não encontrado <br>
        <p>OBS: clique o menu <mat-icon>more_vert</mat-icon> acima e adicione os candidatos</p>
      </span>
    </div>
  </ng-container>

  <mat-selection-list *ngIf="candidateMode === 'contract'" #candidatesForHire>
    <ng-container *ngFor="let candidate of candidates">
      <mat-list-option [value]="candidate.id">
        <h3 matLine>{{ candidate.firstname }} {{ candidate.lastname }}</h3>
        <p matLine>{{ candidate.city }}</p>
        <span matLine *ngIf="candidate.candidateStatus === 'hired'" style="color: #093">Já contratado</span>
      </mat-list-option>
    </ng-container>
  </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions>
  <ng-container *ngIf="(isSmallScreen$ | async) && candidateMode !== 'default'">
    <button mat-button color="primary" (click)="candidateMode = 'default'">
      Voltar
    </button>
  </ng-container>

  <mat-paginator *ngIf="candidates.length > 0" (page)="pageEvent($event)" [length]="totalLeads" [pageSize]="20"
    [pageSizeOptions]="[20, 50, 100]">
  </mat-paginator>

  <button mat-button color="accent" (click)="close()" mat-dialog-close>
    Fechar
  </button>
</mat-dialog-actions>

<mat-menu #matMenuControlMobile>
  <button mat-menu-item (click)="finishProcess()" style="color: red" *ngIf="processListStatus !== 'finished'">
    Encerrar processo seletivo
  </button>
  <ng-container *ngIf="candidateMode === 'default'">
    <button mat-menu-item color="primary" (click)="addCandidate()">
      Adicionar mais candidatos
    </button>
    <button mat-menu-item color="primary" (click)="candidateMode = 'contract'">
      Contratar candidato
    </button>
  </ng-container>
  <ng-container *ngIf="candidateMode === 'contract'">
    <button mat-menu-item color="primary" (click)="hireCandidates()">
      Contratar
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item color="accent" (click)="candidateMode = 'default'" style="color: red">
      Cancelar
    </button>
  </ng-container>

</mat-menu>